import {
    Box, Button, CardContent, FormControlLabel, FormGroup, Switch, TextField, Typography
} from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import api from '../../../services/api';
import React, { Component } from 'react';
import { validateField } from 'lib/functions';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class OpcionalVeiculoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isNewRecord: false,
            isView: false,
            opcionalveiculo: {},
            errors: {},
            schema: {
                descopcionalveiculo: {
                    presence: { allowEmpty: false, message: 'Descrição do opcional obrigatória' },
                    length: { maximum: 64 },
                    type: 'string'
                }
            }
        };
    };

    async componentDidMount() {
        // carrega informações formulário
        const { id } = this.props.match.params;
        const { location } = this.props;
        const currentPath = location.pathname;

        if (id >= 0) {
            const response = await api.get(`/opcionalveiculo/${id}`);
            const dados = response.data.data[0] || {};

            this.setState({
                opcionalveiculo: {
                    ...dados,
                    inativoopc: dados.inativoopc || ANAO
                },
                isNewRecord: false,
                isView: (currentPath.includes('/view'))
            });
        }

        else if (id === 'novo') {
            this.setState({
                isNewRecord: true
            });
            this.state.isNewRecord = true;
        }
    };

    /* Evento on change componentes */
    OnChange = (event) => {
        const { name, type, value, checked } = event.target;

        // ajuste de campos
        let adjustedValue =
            type === 'checkbox' ? (checked ? ANAO : ASIM) :
                type === 'radio' ? Number(value) : value.toUpperCase();

        this.setState(prevState => ({
            opcionalveiculo: {
                ...prevState.opcionalveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Atualiza dados de opcional de veículo existente - post */
    atualizaOpcionalVeiculo = async () => {
        const { opcionalveiculo } = this.state;
        try {
            const response = await api.put(`/opcionalveiculo/${opcionalveiculo.codopcionalveiculo}`, opcionalveiculo);
            if (response.status === 200) {
                this.props.history.push('/frotas/opcionalveiculo');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Click salvar */
    onClickSave = async () => {
        const { opcionalveiculo, isNewRecord } = this.state;
        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');
            return;
        }

        try {
            const codusuarioregistrou = sessionStorage.getItem('codUser') || localStorage.getItem('codUser');
            if (!codusuarioregistrou) {
                console.error('Erro: código do usuário não encontrado!');
                return;
            }

            // usa-se quando não há campos do tipo BLOB
            const payload = {
                descopcionalveiculo: opcionalveiculo.descopcionalveiculo || '',
                inativoopc: opcionalveiculo.inativoopc || ANAO,
                codusuarioregistrou: Number(codusuarioregistrou)
            };

            console.log('Enviando para o backend (JSON):', payload);

            if (isNewRecord) {
                await api.post('/opcionalveiculo', payload);
            } else {
                await api.put(`/opcionalveiculo/${opcionalveiculo.codopcionalveiculo}`, payload);
            }

            if (this.props.loadOpcionaisVeiculo) this.props.loadOpcionaisVeiculo();
            this.props.history.push('/frotas/opcionalveiculo');

        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);
            this.handleOpenAlert(error.response?.data?.error || 'Erro ao salvar!');
        }
    };

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/opcionalveiculo');
    };

    /* Valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { opcionalveiculo, schema } = this.state;
        let errors = {};

        // valida campos do schema
        const requiredFields = [
            'descopcionalveiculo'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, opcionalveiculo[field], schema);
            if (error) {
                errors[field] = error;
            }
        })

        return errors;
    };

    /* Insere novo opcional de veículo */
    insereOpcionalVeiculo = async () => {
        const { opcionalveiculo } = this.state;
        opcionalveiculo.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'));
        try {
            const response = await api.post(`/opcionalveiculo`, opcionalveiculo);
            if (response.status === 200) {
                this.props.history.push('/frotas/opcionalveiculo');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    render() {
        const {
            errors,
            isView,
            messageAlert,
            opcionalveiculo,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Opcional de veículos {opcionalveiculo.codopcionalveiculo}
                        </Typography>

                        <FormControlLabel
                            label={(opcionalveiculo.inativoopc === ASIM) ? 'Inativo' : 'Ativo'}
                            control={
                                <Switch
                                    checked={!(opcionalveiculo.inativoopc === ASIM)}
                                    name="inativoopc"
                                    onChange={this.OnChange}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <br />

                    <TextField
                        label="Descrição"
                        name="descopcionalveiculo"
                        value={opcionalveiculo.descopcionalveiculo || ''}
                        variant="outlined"
                        onChange={this.OnChange}
                        helperText={errors.descopcionalveiculo || ''}
                        error={!!errors.descopcionalveiculo}
                        disabled={isView}
                        inputProps={{ maxLength: 50 }}
                        style={{
                            marginTop: '10px',
                            width: '70%'
                        }}
                    />

                    <br />
                    <br />

                    <Button
                        name="salvar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickSave}
                        style={{ marginTop: '10px' }}
                        disabled={isView}
                    >
                        Salvar
                    </Button>

                    <Button
                        name="cancelar"
                        variant="contained"
                        onClick={this.onClickCancel}
                        color="secondary"
                        style={{
                            marginTop: '10px',
                            marginLeft: '10px'
                        }}
                    >
                        Cancelar
                    </Button>
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div>
        );
    }
}

export default OpcionalVeiculoForm;